import { EVENT_TYPE } from "~/constants";
import { formatEventDateRange } from "./index";

export const formatSearchRequestOptions = (item: IModelSearchOptions): IRequestSearchPayloads => {
  const status = item.type !== EVENT_TYPE.HIGHLIGHT ? item.type : undefined;
  const mediaType = item.type === EVENT_TYPE.HIGHLIGHT ? item.type : undefined;
  const sportType = (Array.isArray(item.sportType) && item.sportType?.join(",")) || undefined;
  const dateOffset = formatEventDateRange(item.dateRange);
  const identityId = item.identityId === "all" ? undefined : item.identityId;
  const gender = item.gender === "all" ? undefined : item.gender;

  const payload: IRequestSearchPayloads = {
    searchString: item.searchString || undefined,
    sportType,
    identityId,
    gender,
    status,
    mediaType,
    dateOffset,
    size: item.size || 12,
    page: item.page || 0,
    order: item.order,
    sort: item.sort,
  };

  if (item.type === EVENT_TYPE.HIGHLIGHT) {
    payload.eventFilters = {
      "identities.type": identityId,
      "gender": gender,
    };
    payload.identityId = undefined;
  }

  return payload;
};

export const formatCategorySearchRequestOptions = (item: IModelCategorySearchOptions): IRequestCategorySearchPayloads => {
  const sportType = (Array.isArray(item.sportType) && item.sportType?.join(",")) || undefined;
  const dateOffset = formatEventDateRange(item.dateOffset);
  const identityId = item.identityId === "all" ? undefined : item.identityId;

  return {
    searchString: item.searchString || undefined,
    sportType,
    identityId,
    dateOffset,
    order: item.order,
    sort: item.sort,
  };
};

export const formatIdentitySubFacetsForMain = (item: IResponseIdentities): IModelIdentitySubFacetsForMain => {
  const relatedIdentities = (item.relatedIdentities ?? []).map((item) => {
    return {
      id: item._id || "",
      title: item.title || "",
      imageUrl: item.content?.PosterH || "",
    };
  });

  return {
    identityId: item.identityId,
    count: item.count,
    identityTitle: item.identityTitle,
    relatedIdentities,
  };
};
